(function () {
  function getSelectedAddonVariants(addOnsEl) {
    return Array.from(addOnsEl.querySelectorAll('[data-vp-addon-variant]'))
      .filter((cb) => cb.checked)
      .map((cb) => ({ id: parseInt(cb.getAttribute('data-vp-addon-variant'), 10), quantity: 1 }));
  }

  function findSubmitBtn(addOnsEl) {
    const sectionId = addOnsEl.dataset.sectionId;
    if (!sectionId) return null;
    const form = document.getElementById(`BuyButtons-ProductForm-${sectionId}`);
    if (!form) return null;
    return form.querySelector('[type="submit"][name="add"]');
  }

  async function addItemsToCart(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Cart error');
    }
    return res.json();
  }

  function bindAddOns(addOnsEl) {
    if (addOnsEl.dataset.vpAddOnsInited) return;
    addOnsEl.dataset.vpAddOnsInited = '1';

    const submitBtn = findSubmitBtn(addOnsEl);
    if (!submitBtn) return;

    submitBtn.addEventListener(
      'click',
      async (e) => {
        // Second pass after we already handled add-ons — let native form proceed
        if (submitBtn.dataset.vpAddonsPassthrough === '1') {
          delete submitBtn.dataset.vpAddonsPassthrough;
          return;
        }

        const addons = getSelectedAddonVariants(addOnsEl);
        if (addons.length === 0) return; // nothing selected — let native form handle everything

        // Stop this click from reaching product-form-component
        e.preventDefault();
        e.stopImmediatePropagation();

        submitBtn.disabled = true;

        try {
          // 1. Add selected add-ons to cart via API
          await addItemsToCart(addons);

          // 2. Re-fire button click — this time the flag lets it pass through
          //    so product-form-component adds the main product and opens the drawer
          submitBtn.dataset.vpAddonsPassthrough = '1';
          submitBtn.disabled = false;
          submitBtn.click();
        } catch (err) {
          console.error('[vp-add-ons] Cart error:', err);
          submitBtn.disabled = false;
        }
      },
      { capture: true }
    );
  }

  function initAll() {
    document.querySelectorAll('[data-vp-add-ons]').forEach(bindAddOns);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
